import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { MapPinOff } from "lucide-react";
import { Button } from "components/ui/button";
import { CategoryNoticeKeys } from "../ObjectSelectionStep/CategoryNotice";

/**
 * The station flows' wording for the room search's category notices (#3429
 * step 3): what the customer is shown there is a list of LOCATIONS, so one
 * set serves sup, rental and storage.
 */
export const STATION_CATEGORY_NOTICE_KEYS: CategoryNoticeKeys = {
  showAll: "book_location.category_notice.station.show_all",
  unknown: "book_location.category_notice.station.unknown",
};

/** "Show all": the same flow without the URL's category. */
export const useShowAllLocations = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  return () => {
    const params = new URLSearchParams(search);
    params.delete("category");
    const rest = params.toString();
    navigate({ pathname, search: rest ? `?${rest}` : "" }, { replace: true });
  };
};

/**
 * A live category that no station offers right now: said as such, with the
 * way back to every location. Not the "closed for the season" screen — the
 * stations are open for the use case's other products.
 */
export const EmptyCategoryState = ({ onShowAll }: { onShowAll: () => void }) => {
  const { t } = useTranslation();
  return (
    <div role="status" className="flex flex-col items-center justify-center gap-3 px-6 py-10 text-center">
      <MapPinOff className="h-8 w-8 text-foreground/40" aria-hidden="true" />
      <p className="text-sm text-foreground/70">{t("book_location.category_notice.station.empty")}</p>
      <Button variant="outline" className="mt-2" onClick={onShowAll}>
        {t(STATION_CATEGORY_NOTICE_KEYS.showAll)}
      </Button>
    </div>
  );
};
